class ApiError extends Error {
  constructor(props) {
    super(props);
    this.name = 'Api Error';
    this.response = props.response;
  }
}

const getErrorMessages = (response) => {
  if (response.status >= 500) {
    return { messages: [{ message: 'MSG_TEXT_SOMETHING_WENT_WRONG' }] };
  }

  if (typeof response.data === 'string') {
    return { messages: [{ message: response.data }] };
  }

  return {};
};

const throwGenericError = (response = {}) => {
  throw new ApiError({
    response: {
      ...response,
      status: 0,
      httpReqStatus: response.status,
      ...getErrorMessages(response),
    },
  }).response;
};

const concatErrorMsgs = (messages) => messages.map(({ message }) => message).join('');

export { ApiError as default, concatErrorMsgs, throwGenericError };
